module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA+klEQVRIS7XVSw4BQRAG4L+GUziQxBG8H7Fi5bEQK7GxsbcRZmQ4g8RJHMA1/DIJiYjp7upmDvB/VdPVXYI/f/LnfBiBWswRiWkU4ZC2MBcRagsyAtU9bwBKz9DdqYO+FjEC9YSr+x2zt6rViBEgKbUYWwA9X8R6yKGIFcgqD0GcgBDEGfBFVIAPogbykAJQSbty/ryIXsCCjK4JEhCNV2ChiHLalEsw8C1cBJtTRwbfnhFVB3nhxzaGeU+IM+ATnnXkBPiGOwEh4VYgNNwKVGOuQUxe05FNi+lA1VP0vnB8wq0d1GMOSYwR4XBsYandZlZAu3/Vv+gXwAOnY58ZhVuRUwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/insurance-new/icon-right-blue.png
// module id = WQus
// module chunks = 4